import React, { useState } from 'react';

const ItemEditForm = ({
  formData,
  categories,
  mode,
  duplicateToast,
  existingBarcodes = [],
  onSubmit,
  onSaveAndDuplicate,
  onInputChange,
  onClose,
  onDelete
}) => {
  const [showExportInfo, setShowExportInfo] = useState(false);

  const barcodeError = (() => {
    if (mode !== 'duplicate') return null;
    const val = (formData.barcode || '').trim();
    if (val === '') return 'UPC is required for a duplicated item.';
    if (existingBarcodes.includes(val)) return 'UPC already exists on another item. Pick a unique one.';
    return null;
  })();

  return (
    <form onSubmit={onSubmit} className="item-form">
      <div className="form-grid">
        <div className="form-group">
          <label>Part Number *</label>
          <input
            type="text"
            name="part_number"
            value={formData.part_number}
            onChange={onInputChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Name *</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={onInputChange}
            required
          />
        </div>
        <div className="form-group">
          <label>UPC / Barcode{mode === 'duplicate' ? ' *' : ''}</label>
          <input
            type="text"
            name="barcode"
            value={formData.barcode}
            onChange={onInputChange}
            required={mode === 'duplicate'}
          />
          {barcodeError && (
            <span className="field-error">{barcodeError}</span>
          )}
        </div>
        <div className="form-group">
          <label>Category</label>
          <select
            name="category_id"
            value={formData.category_id}
            onChange={onInputChange}
          >
            <option value="">No Category</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label>Type</label>
          <select
            name="raw_baked"
            value={formData.raw_baked}
            onChange={onInputChange}
          >
            <option value="">-</option>
            <option value="RAW">Raw</option>
            <option value="BAKED">Baked</option>
            <option value="FRIED">Fried</option>
          </select>
        </div>
        <div className="form-group">
          <label>Weight Per Piece (g)</label>
          <input
            type="number"
            step="0.01"
            name="weight_per_piece"
            value={formData.weight_per_piece}
            onChange={onInputChange}
          />
        </div>
        <div className="form-group">
          <label>Qty in Case</label>
          <input
            type="number"
            name="qty_per_case"
            value={formData.qty_per_case}
            onChange={onInputChange}
          />
        </div>
        <div className="form-group">
          <label>Case Weight (kg)</label>
          <input
            type="number"
            step="0.01"
            name="case_weight"
            className="readonly-field"
            value={formData.case_weight}
            readOnly
          />
          <span className="field-hint">Auto-calculated from weight × qty</span>
        </div>
      </div>

      <div className="export-info-section">
        <button
          type="button"
          className="export-info-toggle"
          onClick={() => setShowExportInfo(!showExportInfo)}
        >
          <span className={`toggle-arrow ${showExportInfo ? 'open' : ''}`}>▶</span>
          Export Info
          <span className="export-info-hint">(FDA, Tariff, USMCA, etc.)</span>
        </button>
        {showExportInfo && (
          <div className="form-grid export-info-grid">
            <div className="form-group">
              <label>Country of Origin</label>
              <input
                type="text"
                name="country_of_origin"
                value={formData.country_of_origin}
                onChange={onInputChange}
              />
            </div>
            <div className="form-group">
              <label>FDA Code</label>
              <input
                type="text"
                name="fda_code"
                value={formData.fda_code}
                onChange={onInputChange}
              />
            </div>
            <div className="form-group">
              <label>Tariff Number</label>
              <input
                type="text"
                name="tariff_number"
                value={formData.tariff_number}
                onChange={onInputChange}
              />
            </div>
            <div className="form-group">
              <label>USMCA</label>
              <input
                type="text"
                name="usmca"
                value={formData.usmca}
                onChange={onInputChange}
              />
            </div>
            <div className="form-group">
              <label>Butter Fat %</label>
              <input
                type="number"
                step="0.01"
                name="butter_fat_pct"
                value={formData.butter_fat_pct}
                onChange={onInputChange}
              />
            </div>
            <div className="form-group">
              <label>Sugar %</label>
              <input
                type="number"
                step="0.01"
                name="sugar_pct"
                value={formData.sugar_pct}
                onChange={onInputChange}
              />
            </div>
            <div className="form-group">
              <label>Cocoa %</label>
              <input
                type="number"
                step="0.01"
                name="cocoa_pct"
                value={formData.cocoa_pct}
                onChange={onInputChange}
              />
            </div>
          </div>
        )}
      </div>

      {duplicateToast && (
        <div className="duplicate-toast">Item created! Edit for next variant.</div>
      )}
      <div className="form-actions">
        {mode === 'edit' && (
          <button type="button" className="delete-btn" onClick={onDelete}>
            Delete
          </button>
        )}
        <div className="form-actions-right">
          <button type="button" className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          {(mode === 'add' || mode === 'duplicate') && (
            <button
              type="button"
              className="duplicate-btn"
              onClick={onSaveAndDuplicate}
              disabled={!!barcodeError}
            >
              Create & Duplicate
            </button>
          )}
          <button
            type="submit"
            className="save-btn"
            disabled={!!barcodeError}
          >
            {(mode === 'add' || mode === 'duplicate') ? 'Add Item' : 'Update'}
          </button>
        </div>
      </div>
    </form>
  );
};

export default ItemEditForm;
